import React from "react"

const Pagination = ({ total, page, pageSize, onChange }) => {
  const totalPages = Math.ceil(total / pageSize)
  if (totalPages <= 1) return null
  const getPages = () => {
    if (totalPages <= 5) return Array.from({ length: totalPages }, (_, i) => i + 1)
    const s = new Set([1, totalPages, page])
    if (page > 1) s.add(page - 1)
    if (page < totalPages) s.add(page + 1)
    return [...s].sort((a, b) => a - b)
  }
  const pages = getPages()
  return (
    <div className="flex items-center justify-between px-4 py-2.5 border-t border-gray-200 bg-gray-50">
      <span className="text-xs text-gray-500">
        {(page - 1) * pageSize + 1}–{Math.min(page * pageSize, total)} з {total}
      </span>
      <div className="flex items-center gap-1">
        <button
          onClick={() => onChange(page - 1)}
          disabled={page === 1}
          className="w-7 h-7 rounded border border-gray-200 text-xs text-gray-500 hover:bg-white disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center"
        >
          ←
        </button>
        {pages.map((p, i) => {
          const prev = pages[i - 1]
          return (
            <div key={p} className="flex items-center gap-1">
              {prev && p - prev > 1 && <span className="text-xs text-gray-300 px-0.5">…</span>}
              <button
                onClick={() => onChange(p)}
                className={`w-7 h-7 rounded border text-xs font-medium ${p === page ? "bg-blue-600 border-blue-600 text-white" : "border-gray-200 text-gray-600 hover:bg-white"}`}
              >
                {p}
              </button>
            </div>
          )
        })}
        <button
          onClick={() => onChange(page + 1)}
          disabled={page === totalPages}
          className="w-7 h-7 rounded border border-gray-200 text-xs text-gray-500 hover:bg-white disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center"
        >
          →
        </button>
      </div>
    </div>
  )
}

export default Pagination
